import {
  siGoogleauthenticator,
  siAegisauthenticator,
  si1password,
  siBitwarden,
  siProton,
} from "simple-icons";

const apps = [
  { icon: siGoogleauthenticator, name: "Google Authenticator" },
  { icon: siAegisauthenticator, name: "Aegis" },
  { icon: si1password, name: "1Password" },
  { icon: siBitwarden, name: "Bitwarden" },
  { icon: siProton, name: "Proton Authenticator" },
];

export function AuthenticatorApps({ className = "" }) {
  return (
    <div className={className}>
      <div className="flex flex-wrap items-center gap-2" aria-label="Example compatible authenticator apps">
        {apps.map(({ icon, name }) => (
          <span key={name} title={name} className="inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs"
            style={{ color: "var(--text)", background: "var(--surface-2)", border: "1px solid var(--border)" }}>
            <svg width="17" height="17" viewBox="0 0 24 24" role="img" aria-label={`${name} logo`}>
              <path fill={`#${icon.hex}`} d={icon.path} />
            </svg>
            {name}
          </span>
        ))}
      </div>
      <p className="text-xs mt-2" style={{ color: "var(--text-muted)" }}>
        Microsoft Authenticator, Authy, Duo Mobile, Apple Passwords, and other apps that support standard 6-digit TOTP codes also work.
      </p>
    </div>
  );
}
